import { calcLineas, formatEur, fmt } from '../store';
import { LOGO_BASE64 } from './logo';

// "Mixto" a secas no dice nada en un ticket/factura impresos — mostrar el
// desglose (ej. "Efectivo: 50,00 € + Tarjeta: 30,50 €").
function textoPago(doc) {
  if (doc.pago === 'Mixto' && Array.isArray(doc.pagoMixtoDetalle) && doc.pagoMixtoDetalle.length) {
    return doc.pagoMixtoDetalle.map(d => `${d.modo}: ${formatEur(d.importe)}`).join(' + ');
  }
  return doc.pago || '—';
}

// eslint-disable-next-line no-useless-concat
const scriptClose = '</s' + 'cript>';

/* ── CSS TÉRMICA mejorado ── */
const thermalCSS = `
  @page { margin: 3mm 2mm; size: 80mm auto; }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; box-sizing: border-box; }
  body {
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    font-weight: 800;
    color: #000 !important;
    margin: 0;
    padding: 6px 4px;
    width: 72mm;
    max-width: 72mm;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.5;
  }

  /* ── Tipografía ── */
  .center  { text-align: center; }
  .right   { text-align: right; }
  .bold    { font-weight: 900 !important; }
  .big     { font-size: 15px; font-weight: 900 !important; letter-spacing: 0.5px; }
  .med     { font-size: 13px; font-weight: 900; }
  .small   { font-size: 11px; font-weight: 800; }
  .xsmall  { font-size: 10px; font-weight: 800; color: #000; }
  .label   { font-size: 10px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.8px; color: #000; }

  /* ── Separadores ── */
  .solid  { border: none; border-top: 2px solid #000 !important; margin: 6px 0; }
  .double { border: none; border-top: 3px double #000 !important; margin: 6px 0; }
  .dashed { border: none; border-top: 1.5px dashed #000 !important; margin: 5px 0; }
  .dotted { border: none; border-top: 1px dotted #333 !important; margin: 4px 0; }

  /* ── Filas clave-valor ── */
  .row     { display: flex; justify-content: space-between; gap: 4px; line-height: 1.6; }
  .row .l  { flex: 1; word-wrap: break-word; overflow-wrap: break-word; }
  .row .r  { text-align: right; white-space: nowrap; min-width: 50px; font-weight: 800; }

  /* ── Sección con etiqueta ── */
  .section-title {
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin: 6px 0 2px 0;
    padding: 2px 4px;
    background: #000;
    color: #fff;
    display: inline-block;
  }
  .section-body {
    padding: 3px 0 3px 4px;
    border-left: 2px solid #000;
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 1.6;
    width: 100%;
    box-sizing: border-box;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  /* ── Tabla artículos ── */
  table    { width: 100%; border-collapse: collapse; font-size: 11.5px; font-weight: 800; }
  th       { border-bottom: 2px solid #000; border-top: 1px solid #000; padding: 4px 3px; font-weight: 900; font-size: 10px; text-align: left; text-transform: uppercase; letter-spacing: 0.5px; }
  td       { padding: 4px 3px; vertical-align: top; font-weight: 800; border-bottom: 1px dotted #555; }
  tr:last-child td { border-bottom: none; }

  /* ── Bloque total ── */
  .total-box {
    border: 2.5px solid #000 !important;
    padding: 6px 10px;
    margin: 5px 0;
    background: #f5f5f5;
  }
  .total-box .big { font-size: 18px; }

  /* ── Sub-totales ── */
  .subtotals { padding: 2px 0; }
  .subtotals .row { line-height: 1.5; }

  /* ── Logo ── */
  .logo-img { display: block; margin: 0 auto 5px auto; max-width: 58mm; max-height: 18mm; }

  /* ── Pie ── */
  .footer-box {
    margin-top: 6px;
    padding-top: 5px;
    border-top: 1px dashed #555;
    text-align: center;
  }

  /* ── Cabecera/pie custom wysiwyg ── */
  .custom-header { font-size: 12px; font-weight: 700; margin-bottom: 4px; }
  .custom-footer  { font-size: 12px; font-weight: 700; margin-top: 4px; }
  .custom-header b, .custom-footer b { font-weight: 900; }
  .custom-header i, .custom-footer i { font-style: italic; }

  /* ── Urgente badge ── */
  .urgente {
    border: 2.5px solid #000;
    padding: 3px 0;
    margin: 4px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 1px;
  }
`;

/* ══════════════════════════════════════════
   TICKET DE VENTA
══════════════════════════════════════════ */
export function printTicket(doc, config) {
  const { base, total } = calcLineas(doc.lineas);
  const ivasPorTipo = {};
  doc.lineas.forEach(l => {
    const k = l.iva;
    if (!ivasPorTipo[k]) ivasPorTipo[k] = 0;
    ivasPorTipo[k] += l.cant * l.precio * l.iva / 100;
  });

  const useLogo      = config.ticketUsarLogo !== false;
  const cabeceraHtml = config.ticketCabecera || '';
  const pieHtml      = config.ticketPie      || '';

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${doc.num}</title>
  <style>${thermalCSS}</style></head><body>

  ${useLogo && LOGO_BASE64
    ? `<img src="${LOGO_BASE64}" class="logo-img" alt="logo"/>`
    : `<div class="center big">${config.nombre.toUpperCase()}</div>`}

  ${cabeceraHtml
    ? `<div class="custom-header center">${cabeceraHtml}</div>`
    : `<div class="center small">${config.direccion}</div>
       <div class="center small">Tel: ${config.telefono}</div>
       ${config.web ? `<div class="center small">${config.web}</div>` : ''}`}

  <div class="double"></div>
  ${doc.tipo && doc.tipo !== 'TICKET'
    ? `<div class="center med bold" style="margin:3px 0;letter-spacing:1px">${doc.tipo}</div><div class="solid"></div>`
    : ''}

  <div class="row"><span class="l label">Nº ticket</span><span class="r bold med">${doc.num}</span></div>
  <div class="dotted"></div>
  <div class="row"><span class="l">Fecha</span><span class="r">${fmt(doc.fecha)}</span></div>
  <div class="row"><span class="l">Pago</span><span class="r">${textoPago(doc)}</span></div>
  ${doc.clienteNombre ? `<div class="row"><span class="l">Cliente</span><span class="r">${doc.clienteNombre}</span></div>` : ''}

  <div class="double"></div>

  <table style="table-layout:fixed;width:100%">
    <thead><tr>
      <th style="width:44%">Artículo</th>
      <th style="text-align:center;width:9%">Ud</th>
      <th style="text-align:right;width:23%">P.u.</th>
      <th style="text-align:right;width:24%">Total</th>
    </tr></thead>
    <tbody>
      ${doc.lineas.map(l => `
        <tr>
          <td style="word-wrap:break-word;overflow-wrap:break-word">${l.desc}</td>
          <td style="text-align:center">${l.cant}</td>
          <td style="text-align:right">${l.precio.toFixed(2)}</td>
          <td style="text-align:right;font-weight:900">${(l.cant * l.precio).toFixed(2)}</td>
        </tr>`).join('')}
    </tbody>
  </table>

  <div class="solid"></div>
  <div class="subtotals">
    <div class="row small"><span class="l">Base imponible</span><span class="r">${formatEur(base)}</span></div>
    ${Object.entries(ivasPorTipo).map(([k, v]) =>
      `<div class="row small"><span class="l">IVA ${k}%</span><span class="r">${formatEur(v)}</span></div>`
    ).join('')}
  </div>
  <div class="total-box">
    <div class="row big bold"><span class="l">TOTAL</span><span class="r">${formatEur(total)}</span></div>
  </div>
  ${parseFloat(doc.senal) > 0 ? `
  <div class="subtotals" style="margin-top:4px">
    <div class="row small"><span class="l">Señal entregada</span><span class="r bold" style="color:#0e9f6e">- ${formatEur(parseFloat(doc.senal))}</span></div>
    <div class="row small bold"><span class="l">Resto a pagar</span><span class="r bold">${formatEur(Math.max(0, total - parseFloat(doc.senal)))}</span></div>
  </div>` : ''}

  <div class="footer-box">
    ${pieHtml
      ? `<div class="custom-footer">${pieHtml}</div>`
      : `<div class="small bold">✦ GRACIAS POR SU COMPRA ✦</div>
         <div class="xsmall" style="margin-top:2px">IVA incluido · ${config.nombre}</div>`}
  </div>

  <div style="margin-top:8px">&nbsp;</div>
  <div>&nbsp;</div>
  <div class="dashed"></div>

  <script>window.onload=()=>{ setTimeout(()=>window.print(),200); }${scriptClose}
  </body></html>`);
  w.document.close();
}

/* ══════════════════════════════════════════
   ETIQUETA REDUCIDA REPARACIÓN (nombre + tel + avería)
══════════════════════════════════════════ */
export function printEtiquetaReparacion(rep, config) {
  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${rep.num}-ETIQUETA</title>
  <style>${thermalCSS}</style></head><body>

  <div class="center small" style="margin-bottom:1px">${config.nombre.toUpperCase()}</div>
  <div class="double"></div>
  <div class="center big bold" style="letter-spacing:2px">${rep.num}</div>
  <div class="double"></div>

  <div class="section-title">Cliente</div>
  <div class="section-body">
    <div class="bold med">${rep.clienteNombre}</div>
    <div class="small">Tel: ${rep.clienteTel || '—'}</div>
  </div>

  <div class="section-title">Equipo</div>
  <div class="section-body">
    <div class="bold small">${rep.tipoEquipo ? rep.tipoEquipo + ' — ' : ''}${rep.equipo}</div>
    ${rep.accesorios ? `<div class="small">Accesorios: ${rep.accesorios}</div>` : ''}
  </div>

  <div class="section-title">Avería</div>
  <div class="section-body small" style="font-size:11.5px;line-height:1.6;white-space:pre-line">${rep.averia || '—'}</div>

  ${rep.pin ? `<div class="dotted" style="margin-top:4px"></div>
  <div class="row"><span class="l label">PIN / Contraseña</span><span class="r bold med">${rep.pin}</span></div>` : ''}

  <div class="dotted" style="margin-top:6px"></div>
  <div class="center xsmall">${fmt(rep.fecha)}</div>

  <div style="margin-top:8px">&nbsp;</div>
  <div>&nbsp;</div>
  <div class="dashed"></div>

  <script>window.onload=()=>{ setTimeout(()=>window.print(),200); }${scriptClose}
  </body></html>`);
  w.document.close();
}

/* ══════════════════════════════════════════
   RESGUARDO ENTRADA REPARACIÓN
══════════════════════════════════════════ */
export function printReparacion(rep, config) {
  const useLogo      = config.ticketUsarLogo !== false;
  const cabeceraHtml = config.ticketCabecera || '';
  const pieHtml      = config.ticketPie      || '';

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${rep.num}-ENTRADA</title>
  <style>${thermalCSS}</style></head><body>

  ${useLogo && LOGO_BASE64
    ? `<img src="${LOGO_BASE64}" class="logo-img" alt="logo"/>`
    : `<div class="center big">${config.nombre.toUpperCase()}</div>`}

  ${cabeceraHtml
    ? `<div class="custom-header center">${cabeceraHtml}</div>`
    : `<div class="center small">${config.direccion}</div>
       <div class="center small">Tel: ${config.telefono}</div>`}

  <div class="double"></div>
  <div class="center med bold" style="letter-spacing:1px">RESGUARDO DE REPARACIÓN</div>
  <div class="double"></div>

  <div class="row">
    <span class="l label">Nº reparación</span>
    <span class="r bold med">${rep.num}</span>
  </div>
  <div class="row small"><span class="l">Fecha entrada</span><span class="r">${fmt(rep.fecha)}</span></div>

  ${rep.urgencia === 'No prioritario'
    ? `<div class="dotted"></div><div class="center xsmall" style="margin-bottom:3px">🐢 No prioritario</div>`
    : rep.urgencia === 'Urgente'
      ? `<div class="urgente">⚠ URGENTE ⚠</div>`
      : rep.urgencia === 'Muy urgente'
        ? `<div style="background:#000;color:#fff;padding:5px 0;margin:4px 0;text-align:center;font-size:15px;font-weight:900;letter-spacing:2px">🔴 MUY URGENTE 🔴</div>`
        : `<div class="dotted"></div>`}

  <div class="section-title">Cliente</div>
  <div class="section-body">
    <div class="bold">${rep.clienteNombre}</div>
    <div class="small">Tel: ${rep.clienteTel}</div>
  </div>

  <div class="section-title">Equipo</div>
  <div class="section-body">
    <div class="bold">${rep.tipoEquipo ? rep.tipoEquipo + ' — ' : ''}${rep.equipo}</div>
    ${rep.sn         ? `<div class="small">S/N: ${rep.sn}</div>` : ''}
    ${rep.serieRoot  ? `<div class="small">Ref. Root: ${rep.serieRoot}</div>` : ''}
    ${rep.accesorios ? `<div class="small">Accesorios: ${rep.accesorios}</div>` : ''}
  </div>

  <div class="section-title">Avería declarada</div>
  <div class="section-body small" style="font-size:11.5px;line-height:1.6;white-space:pre-line">${rep.averia}</div>

  <div class="dotted"></div>
  ${rep.presupMax
    ? `<div class="row"><span class="l small">Presupuesto aprox.</span><span class="r bold">${rep.presupMax} €</span></div>`
    : `<div class="row small"><span class="l">Presupuesto aprox.</span><span class="r">Pendiente</span></div>`}

  <div class="double"></div>

  <div class="footer-box">
    ${pieHtml
      ? `<div class="custom-footer">${pieHtml}</div>`
      : `<div class="small bold">Guarde este resguardo para recoger su equipo</div>
         <div class="dashed" style="margin:5px 0"></div>
         <div class="center small bold">Compruebe el estado de tu reparación:</div>
         <div class="center bold" style="font-size:14px;letter-spacing:0.5px;margin-top:3px;text-decoration:underline">WWW.SISTEMASROOT.COM/ESTADO</div>`}
  </div>

  <div style="margin-top:8px">&nbsp;</div>
  <div>&nbsp;</div>
  <div style="text-align:center;font-weight:700;margin:6px 0;font-size:11px">Este resguardo tiene validez de 3 meses</div>
  <div class="dashed"></div>

  <script>window.onload=()=>{ setTimeout(()=>window.print(),200); }${scriptClose}
  </body></html>`);
  w.document.close();
}

/* ══════════════════════════════════════════
   TICKET DE ENTREGA REPARACIÓN
══════════════════════════════════════════ */
export function printEntregaReparacion(rep, config) {
  const lineas = rep.lineasEntrega || [];
  const lineasEfectivas = lineas.length
    ? lineas
    : [{ desc: 'Reparación', cant: 1, precio: parseFloat(rep.coste) || 0, iva: 21 }];
  const { base, total } = calcLineas(lineasEfectivas);
  const ivasPorTipo = {};
  lineasEfectivas.forEach(l => {
    const k = l.iva;
    if (!ivasPorTipo[k]) ivasPorTipo[k] = 0;
    ivasPorTipo[k] += l.cant * l.precio * l.iva / 100;
  });

  const useLogo      = config.ticketUsarLogo !== false;
  const cabeceraHtml = config.ticketCabecera || '';
  const pieHtml      = config.ticketPie      || '';

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${rep.num}-ENTREGA</title>
  <style>${thermalCSS}</style></head><body>

  ${useLogo && LOGO_BASE64
    ? `<img src="${LOGO_BASE64}" class="logo-img" alt="logo"/>`
    : `<div class="center big">${config.nombre.toUpperCase()}</div>`}

  ${cabeceraHtml
    ? `<div class="custom-header center">${cabeceraHtml}</div>`
    : `<div class="center small">${config.direccion}</div>
       <div class="center small">Tel: ${config.telefono}</div>`}

  <div class="double"></div>
  <div class="center med bold" style="letter-spacing:1px">TICKET DE ENTREGA</div>
  <div class="double"></div>

  <div class="row">
    <span class="l label">Nº reparación</span>
    <span class="r bold med">${rep.num}</span>
  </div>
  <div class="dotted"></div>
  <div class="row small"><span class="l">Fecha entrada</span><span class="r">${fmt(rep.fecha)}</span></div>
  <div class="row small"><span class="l">Fecha entrega</span><span class="r bold">${fmt(rep.fechaEntrega || new Date().toISOString().slice(0, 10))}</span></div>

  <div class="section-title">Cliente</div>
  <div class="section-body">
    <div class="bold">${rep.clienteNombre}</div>
    <div class="small">Tel: ${rep.clienteTel}</div>
  </div>

  <div class="section-title">Equipo</div>
  <div class="section-body">
    <div class="bold">${rep.tipoEquipo ? rep.tipoEquipo + ' — ' : ''}${rep.equipo}</div>
    ${rep.sn ? `<div class="small">S/N: ${rep.sn}</div>` : ''}
  </div>

  ${rep.trabajos ? `
  <div class="section-title">Trabajos realizados</div>
  <div class="section-body small" style="font-size:11.5px;line-height:1.6;white-space:pre-line">${rep.trabajos}</div>` : ''}

  <div class="solid"></div>

  <table style="table-layout:fixed;width:100%">
    <thead><tr>
      <th style="width:44%">Concepto</th>
      <th style="text-align:center;width:9%">Ud</th>
      <th style="text-align:right;width:23%">P.u.</th>
      <th style="text-align:right;width:24%">Total</th>
    </tr></thead>
    <tbody>
      ${lineasEfectivas.map(l => `
        <tr>
          <td style="word-wrap:break-word;overflow-wrap:break-word">${l.desc}</td>
          <td style="text-align:center">${l.cant}</td>
          <td style="text-align:right">${parseFloat(l.precio).toFixed(2)}</td>
          <td style="text-align:right;font-weight:900">${(l.cant * l.precio).toFixed(2)}</td>
        </tr>`).join('')}
    </tbody>
  </table>

  <div class="solid"></div>
  <div class="subtotals">
    <div class="row small"><span class="l">Base imponible</span><span class="r">${formatEur(base)}</span></div>
    ${Object.entries(ivasPorTipo).map(([k, v]) =>
      `<div class="row small"><span class="l">IVA ${k}%</span><span class="r">${formatEur(v)}</span></div>`
    ).join('')}
  </div>
  <div class="total-box">
    <div class="row big bold"><span class="l">TOTAL</span><span class="r">${formatEur(total)}</span></div>
  </div>

  ${rep.pago
    ? `<div class="row small" style="margin-top:4px"><span class="l">Forma de pago</span><span class="r bold">${rep.pago}</span></div>`
    : ''}

  <div class="footer-box" style="margin-top:6px">
    ${pieHtml
      ? `<div class="custom-footer">${pieHtml}</div>`
      : `<div class="small bold">Garantía de reparación: 3 meses</div>
         <div class="xsmall" style="margin-top:2px">${config.nombre} · ${config.telefono}</div>`}
  </div>

  <div style="margin-top:8px">&nbsp;</div>
  <div>&nbsp;</div>
  <div class="dashed"></div>

  <script>window.onload=()=>{ setTimeout(()=>window.print(),200); }${scriptClose}
  </body></html>`);
  w.document.close();
}

/* ══════════════════════════════════════════
   FACTURA A4
══════════════════════════════════════════ */
export async function printFactura(doc, config) {
  const { base, iva, total } = calcLineas(doc.lineas);
  const useLogo = config.facturaUsarLogo !== false;

  // QR VERI*FACTU generado localmente (sin enviar datos a servicios externos)
  let vfQRHtml = '';
  if (doc.vf_huella) {
    try {
      const QRCode = (await import('qrcode')).default;
      const [fy, fm, fd] = doc.fecha.split('-');
      const fechaAEAT = fd + '-' + fm + '-' + fy;
      const totalVal = (doc.lineas||[]).reduce((s,l) => s + l.cant * l.precio * (1 + l.iva / 100), 0).toFixed(2);
      const qrTarget = 'https://www2.agenciatributaria.gob.es/wlpl/TIND-CONT/ValidarQR'
        + '?nif=' + encodeURIComponent(config.cif || '')
        + '&numserie=' + encodeURIComponent(doc.num)
        + '&fecha=' + encodeURIComponent(fechaAEAT)
        + '&importe=' + encodeURIComponent(totalVal)
        + '&huella=' + encodeURIComponent(doc.vf_huella.substring(0, 8));
      const dataUrl = await QRCode.toDataURL(qrTarget, { width: 72, margin: 1 });
      vfQRHtml = '<div style="margin-top:8px;display:flex;align-items:flex-end;gap:12px;page-break-inside:avoid">'
        + '<img src="' + dataUrl + '" width="72" height="72" alt="QR AEAT" style="display:block"/>'
        + '<span style="font-size:8px;color:#9ca3af;line-height:1.4">Verifica esta<br/>factura en AEAT</span>'
        + '</div>';
    } catch (_) {}
  }

  const w = window.open('', '_blank');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
  <title>${doc.num}</title>
  <style>
    @page { margin: 14mm 16mm; size: A4; }
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #111; margin: 0; padding: 24px; }
    .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; padding-bottom: 16px; border-bottom: 3px solid #1a56db; page-break-inside: avoid; }
    .logo-a4 { max-height: 55px; max-width: 200px; object-fit: contain; }
    .logo-txt { font-size: 22px; font-weight: 900; color: #1a56db; letter-spacing: -0.5px; }
    .empresa-info { font-size: 11px; color: #555; margin-top: 6px; line-height: 1.7; }
    .empresa-sub  { font-size: 10px; color: #999; font-style: italic; margin-top: 2px; }
    .tipo { font-size: 26px; font-weight: 900; color: #1a56db; letter-spacing: 1px; }
    .doc-meta { font-size: 12px; color: #444; margin-top: 6px; line-height: 1.8; }
    .doc-num  { font-size: 15px; font-weight: 800; color: #111; }
    .cliente-box {
      background: #f4f7ff;
      padding: 12px 16px;
      border-radius: 6px;
      margin-bottom: 20px;
      border-left: 4px solid #1a56db;
      page-break-inside: avoid;
    }
    .cliente-label { font-size: 10px; font-weight: 800; color: #1a56db; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 5px; }
    .cliente-nombre { font-size: 14px; font-weight: 700; color: #111; }
    .cliente-data { font-size: 11px; color: #555; margin-top: 3px; line-height: 1.6; }
    table { width: 100%; border-collapse: collapse; margin: 0 0 16px 0; page-break-inside: auto; }
    thead { display: table-header-group; }
    thead tr { background: #1a56db; }
    th { color: #fff; padding: 9px 12px; text-align: left; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
    td { padding: 9px 12px; border-bottom: 1px solid #e8ecf0; font-size: 12px; color: #222; }
    tbody tr { page-break-inside: avoid; }
    tbody tr:nth-child(even) td { background: #f8f9fb; }
    tbody tr:last-child td { border-bottom: 2px solid #1a56db; }
    .totals-wrap { display: flex; justify-content: flex-end; margin-bottom: 20px; page-break-inside: avoid; }
    .totals-table { min-width: 260px; border: 1px solid #dde3ec; border-radius: 6px; overflow: hidden; }
    .totals-table td { padding: 7px 14px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
    .totals-table tr:last-child td { border-bottom: none; font-size: 15px; font-weight: 900; color: #1a56db; background: #eef3ff; }
    .pago-box { padding: 10px 16px; background: #f4f7ff; border-radius: 6px; border-left: 4px solid #1a56db; font-size: 12px; margin-bottom: 24px; page-break-inside: avoid; }
    .footer { padding-top: 12px; border-top: 1px solid #dde3ec; font-size: 10px; color: #999; line-height: 1.7; page-break-inside: avoid; }
    .banco-box { page-break-inside: avoid; }
    @media print { body { padding: 0; } }
  </style></head><body>

  <div class="header">
    <div>
      ${useLogo && LOGO_BASE64
        ? `<img src="${LOGO_BASE64}" class="logo-a4" alt="${config.nombre}"/>`
        : `<div class="logo-txt">${config.nombre}</div>`}
      <div class="empresa-sub">Root Imported Technologies SL</div>
      <div class="empresa-info">
        ${config.direccion}<br/>
        CIF: ${config.cif} &nbsp;·&nbsp; Tel: ${config.telefono}<br/>
        ${config.email}${config.web ? ` &nbsp;·&nbsp; ${config.web}` : ''}
      </div>
    </div>
    <div style="text-align:right">
      <div class="tipo">${doc.tipo || 'FACTURA'}</div>
      <div class="doc-meta">
        <div class="doc-num">Nº ${doc.num}</div>
        <div>Fecha: <b>${fmt(doc.fecha)}</b></div>
        ${doc.validez ? `<div>Válida hasta: <b>${fmt(doc.validez)}</b></div>` : ''}
      </div>
    </div>
  </div>

  ${(doc.clienteNombre || doc.clienteNif) ? `
  <div class="cliente-box">
    <div class="cliente-label">Cliente</div>
    <div class="cliente-nombre">${doc.clienteNombre || ''}</div>
    <div class="cliente-data">
      ${doc.clienteNif       ? `NIF/CIF: ${doc.clienteNif}<br/>` : ''}
      ${doc.clienteDireccion ? `${doc.clienteDireccion}` : ''}
    </div>
  </div>` : ''}

  <table>
    <thead><tr>
      <th>Descripción</th>
      <th style="text-align:center;width:60px">Uds.</th>
      <th style="text-align:right;width:110px">Precio unit.</th>
      <th style="text-align:center;width:60px">IVA</th>
      <th style="text-align:right;width:110px">Total</th>
    </tr></thead>
    <tbody>
      ${doc.lineas.map(l =>
        `<tr>
          <td>${l.desc}</td>
          <td style="text-align:center">${l.cant}</td>
          <td style="text-align:right">${formatEur(l.precio)}</td>
          <td style="text-align:center;color:#555">${l.iva}%</td>
          <td style="text-align:right;font-weight:700">${formatEur(l.cant * l.precio)}</td>
        </tr>`
      ).join('')}
    </tbody>
  </table>

  <div class="totals-wrap">
    <table class="totals-table">
      <tr><td style="color:#555">Base imponible</td><td style="text-align:right">${formatEur(base)}</td></tr>
      <tr><td style="color:#555">IVA</td><td style="text-align:right">${formatEur(iva)}</td></tr>
      <tr><td><b>TOTAL</b></td><td style="text-align:right"><b>${formatEur(total)}</b></td></tr>
      ${parseFloat(doc.senal) > 0 ? `
      <tr><td style="color:#0e9f6e;padding-top:6px">Señal entregada</td><td style="text-align:right;color:#0e9f6e;padding-top:6px">- ${formatEur(parseFloat(doc.senal))}</td></tr>
      <tr style="border-top:2px solid #111"><td><b>Resto a pagar</b></td><td style="text-align:right"><b>${formatEur(Math.max(0, total - parseFloat(doc.senal)))}</b></td></tr>
      ` : ''}
    </table>
  </div>

  <div class="pago-box"><b>Forma de pago:</b> ${textoPago(doc)}</div>

  ${doc.observaciones ? `<div style="margin-bottom:20px;padding:12px 16px;border-radius:6px;background:#fffbeb;border-left:4px solid #f59e0b;font-size:12px;color:#222;page-break-inside:avoid"><b style="display:block;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#b45309;margin-bottom:5px">Observaciones</b>${doc.observaciones.replace(/\n/g,'<br/>')}</div>` : ''}

  <div class="banco-box" style="margin-bottom:20px;padding:14px 18px;border-radius:6px;background:#f8faff;border:1.5px solid #c7d7f5;display:flex;align-items:flex-start;gap:14px">
    <div style="flex-shrink:0;width:36px;height:36px;background:#e63012;border-radius:6px;display:flex;align-items:center;justify-content:center">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="6" width="20" height="13" rx="2" stroke="white" stroke-width="2"/><path d="M2 10h20" stroke="white" stroke-width="2"/><path d="M6 15h4" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
    </div>
    <div>
      <div style="font-size:10px;font-weight:800;color:#1a56db;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">Datos bancarios para pago por ingreso / transferencia</div>
      <div style="font-size:12px;color:#222;line-height:1.9">
        <b>Banco:</b> Santander<br/>
        <b>IBAN:</b> <span style="font-family:monospace;letter-spacing:0.5px">ES68 0030 1010 6403 2100 1273</span><br/>
        <b>Titular:</b> Root Imported Technologies, S.L.
      </div>
    </div>
  </div>

  <div class="footer">
    ${config.nombre}${config.web ? ` &nbsp;·&nbsp; ${config.web}` : ''}<br/>
    Esta factura es documento de pago válido. Conserve para su contabilidad.
    ${doc.vf_huella ? '<br/><span style="font-size:9px;color:#6b7280">VERI*FACTU · Huella: ' + doc.vf_huella.substring(0,16) + '…' + (doc.vf_csv ? ' · CSV: ' + doc.vf_csv : '') + '</span>' : ''}
  </div>

  ${vfQRHtml}

  <div style="margin-top:8px">&nbsp;</div>
  <div>&nbsp;</div>
  <div class="dashed"></div>

  <script>window.onload=()=>{ setTimeout(()=>window.print(),200); }${scriptClose}
  </body></html>`);
  w.document.close();
}

/* ══════════════════════════════════════════
   HELPERS PDF TÉRMICO
══════════════════════════════════════════ */
function mountTicketContainer(innerHtml) {
  const div = document.createElement('div');
  div.style.cssText = "position:fixed;left:-9999px;top:0;width:272px;font-family:'Courier New',Courier,monospace;font-size:12px;font-weight:800;color:#000;padding:6px 4px;background:#fff;word-wrap:break-word;overflow-wrap:break-word;line-height:1.5;";
  div.innerHTML = innerHtml;
  document.body.appendChild(div);
  return div;
}

async function renderToPdf(div, filename) {
  const { jsPDF }   = await import('jspdf');
  const html2canvas = (await import('html2canvas')).default;
  const canvas = await html2canvas(div, { scale: 1.5, backgroundColor: '#fff', useCORS: true });
  document.body.removeChild(div);
  const imgData = canvas.toDataURL('image/jpeg', 0.82);
  const pdfW    = 80;
  const pdfH    = Math.ceil((canvas.height * pdfW) / canvas.width);
  const pdf = new jsPDF({ unit: 'mm', format: [pdfW, pdfH], orientation: 'portrait' });
  pdf.addImage(imgData, 'JPEG', 0, 0, pdfW, pdfH);
  pdf.save(filename);
}

async function renderToJpg(div, filename) {
  const html2canvas = (await import('html2canvas')).default;
  const canvas = await html2canvas(div, { scale: 2, backgroundColor: '#fff', useCORS: true });
  document.body.removeChild(div);
  const dataUrl = canvas.toDataURL('image/png');
  const blob    = await fetch(dataUrl).then(r => r.blob());
  const url     = URL.createObjectURL(blob);
  const a       = document.createElement('a');
  a.href = url; a.download = filename.replace(/\.jpg$/, '.png');
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

function pdfTRow(label, value, small) {
  return '<div style="display:flex;justify-content:space-between;gap:4px;line-height:1.6;' + (small ? 'font-size:11px;' : '') + '"><span style="flex:1;word-wrap:break-word">' + label + '</span><span style="text-align:right;white-space:nowrap;min-width:50px;font-weight:900">' + value + '</span></div>';
}
function pdfTSep(style) {
  const b = { solid:'2px solid #000', double:'3px double #000', dashed:'1.5px dashed #000', dotted:'1px dotted #333' };
  return '<div style="border:none;border-top:' + (b[style || 'solid']) + ';margin:6px 0"></div>';
}
function pdfTSection(title, body) {
  return '<div style="font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.8px;margin:6px 0 2px 0;padding:2px 4px;background:#000;color:#fff;display:inline-block">' + title + '</div><div style="padding:3px 0 3px 4px;border-left:2px solid #000;margin-bottom:4px;font-size:12px;line-height:1.6;width:100%;box-sizing:border-box;word-break:break-word;overflow-wrap:anywhere">' + body + '</div>';
}

function buildResguardoHtml(rep, config) {
  const useLogo      = config.ticketUsarLogo !== false;
  const cabeceraHtml = config.ticketCabecera || '';
  const pieHtml      = config.ticketPie      || '';

  const urgBadge = rep.urgencia === 'No prioritario'
    ? pdfTSep('dotted') + '<div style="text-align:center;font-size:10px;margin-bottom:3px">No prioritario</div>'
    : rep.urgencia === 'Urgente'
      ? '<div style="border:2.5px solid #000;padding:3px 0;margin:4px 0;text-align:center;font-size:14px;font-weight:900;letter-spacing:1px">URGENTE</div>'
      : rep.urgencia === 'Muy urgente'
        ? '<div style="background:#000;color:#fff;padding:5px 0;margin:4px 0;text-align:center;font-size:15px;font-weight:900;letter-spacing:2px">MUY URGENTE</div>'
        : pdfTSep('dotted');

  const header = (useLogo && LOGO_BASE64)
    ? '<img src="' + LOGO_BASE64 + '" style="display:block;margin:0 auto 5px auto;max-width:210px;max-height:60px" alt="logo"/>'
    : '<div style="text-align:center;font-size:15px;font-weight:900;letter-spacing:.5px">' + config.nombre.toUpperCase() + '</div>';

  const subheader = cabeceraHtml
    ? '<div style="text-align:center;font-size:12px;font-weight:700;margin-bottom:4px">' + cabeceraHtml + '</div>'
    : '<div style="text-align:center;font-size:11px">' + config.direccion + '</div><div style="text-align:center;font-size:11px">Tel: ' + config.telefono + '</div>';

  const pie = pieHtml
    ? '<div style="font-size:12px;font-weight:700;margin-top:4px;text-align:center">' + pieHtml + '</div>'
    : '<div style="font-size:11px;font-weight:900;text-align:center">Guarde este resguardo para recoger su equipo</div><div style="border:none;border-top:1.5px dashed #000;margin:5px 0"></div><div style="font-size:13px;font-weight:900;text-align:center">Compruebe el estado de tu reparacion:</div><div style="text-align:center;font-size:14px;font-weight:900;letter-spacing:.5px;margin-top:3px;text-decoration:underline">WWW.SISTEMASROOT.COM/ESTADO</div>';

  return header + subheader
    + pdfTSep('double')
    + '<div style="text-align:center;font-size:13px;font-weight:900;letter-spacing:1px">RESGUARDO DE REPARACION</div>'
    + pdfTSep('double')
    + pdfTRow('<span style="font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.8px">N reparacion</span>', '<span style="font-size:13px;font-weight:900">' + rep.num + '</span>')
    + '<div style="display:flex;justify-content:space-between;font-size:11px;line-height:1.6"><span>Fecha entrada</span><span style="font-weight:900">' + fmt(rep.fecha) + '</span></div>'
    + urgBadge
    + pdfTSection('Cliente', '<div style="font-weight:900">' + rep.clienteNombre + '</div><div style="font-size:11px">Tel: ' + (rep.clienteTel || '—') + '</div>')
    + pdfTSection('Equipo', '<div style="font-weight:900">' + (rep.tipoEquipo ? rep.tipoEquipo + ' - ' : '') + rep.equipo + '</div>'
        + (rep.sn        ? '<div style="font-size:11px">S/N: ' + rep.sn + '</div>' : '')
        + (rep.serieRoot ? '<div style="font-size:11px">Ref. Root: ' + rep.serieRoot + '</div>' : '')
        + (rep.accesorios? '<div style="font-size:11px">Accesorios: ' + rep.accesorios + '</div>' : ''))
    + pdfTSection('Averia declarada', '<div style="font-size:11.5px;line-height:1.6;white-space:pre-line">' + rep.averia + '</div>')
    + pdfTSep('dotted')
    + pdfTRow('<span style="font-size:11px">Presupuesto aprox.</span>', '<span style="font-weight:900">' + (rep.presupMax ? rep.presupMax + ' EUR' : 'Pendiente') + '</span>')
    + '<div style="margin-top:6px;padding-top:5px;border-top:1px dashed #555;text-align:center">' + pie + '</div>';
}

function buildEntregaHtml(rep, config) {
  const lineas = rep.lineasEntrega || [];
  const lineasEfectivas = lineas.length
    ? lineas
    : [{ desc: 'Reparacion', cant: 1, precio: parseFloat(rep.coste) || 0, iva: 21 }];
  const { base, total } = calcLineas(lineasEfectivas);
  const ivasPorTipo = {};
  lineasEfectivas.forEach(function(l) {
    if (!ivasPorTipo[l.iva]) ivasPorTipo[l.iva] = 0;
    ivasPorTipo[l.iva] += l.cant * l.precio * l.iva / 100;
  });

  const useLogo      = config.ticketUsarLogo !== false;
  const cabeceraHtml = config.ticketCabecera || '';
  const pieHtml      = config.ticketPie      || '';

  const header = (useLogo && LOGO_BASE64)
    ? '<img src="' + LOGO_BASE64 + '" style="display:block;margin:0 auto 5px auto;max-width:210px;max-height:60px" alt="logo"/>'
    : '<div style="text-align:center;font-size:15px;font-weight:900;letter-spacing:.5px">' + config.nombre.toUpperCase() + '</div>';

  const subheader = cabeceraHtml
    ? '<div style="text-align:center;font-size:12px;font-weight:700;margin-bottom:4px">' + cabeceraHtml + '</div>'
    : '<div style="text-align:center;font-size:11px">' + config.direccion + '</div><div style="text-align:center;font-size:11px">Tel: ' + config.telefono + '</div>';

  const pie = pieHtml
    ? '<div style="font-size:12px;font-weight:700;margin-top:4px;text-align:center">' + pieHtml + '</div>'
    : '<div style="font-size:11px;font-weight:900;text-align:center">Garantia de reparacion: 3 meses</div><div style="font-size:10px;margin-top:2px;text-align:center">' + config.nombre + ' · ' + config.telefono + '</div>';

  const filasLineas = lineasEfectivas.map(function(l) {
    return '<tr>'
      + '<td style="word-wrap:break-word;overflow-wrap:break-word;padding:4px 3px;border-bottom:1px dotted #555;font-size:11.5px;font-weight:800">' + l.desc + '</td>'
      + '<td style="text-align:center;padding:4px 3px;border-bottom:1px dotted #555;font-size:11.5px;font-weight:800">' + l.cant + '</td>'
      + '<td style="text-align:right;padding:4px 3px;border-bottom:1px dotted #555;font-size:11.5px;font-weight:800">' + parseFloat(l.precio).toFixed(2) + '</td>'
      + '<td style="text-align:right;padding:4px 3px;border-bottom:1px dotted #555;font-size:11.5px;font-weight:900">' + (l.cant * l.precio).toFixed(2) + '</td>'
      + '</tr>';
  }).join('');

  const ivaRows = Object.entries(ivasPorTipo).map(function(entry) {
    return pdfTRow('IVA ' + entry[0] + '%', formatEur(entry[1]), true);
  }).join('');

  return header + subheader
    + pdfTSep('double')
    + '<div style="text-align:center;font-size:13px;font-weight:900;letter-spacing:1px">TICKET DE ENTREGA</div>'
    + pdfTSep('double')
    + pdfTRow('<span style="font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.8px">N reparacion</span>', '<span style="font-size:13px;font-weight:900">' + rep.num + '</span>')
    + pdfTSep('dotted')
    + '<div style="display:flex;justify-content:space-between;font-size:11px;line-height:1.6"><span>Fecha entrada</span><span style="font-weight:900">' + fmt(rep.fecha) + '</span></div>'
    + '<div style="display:flex;justify-content:space-between;font-size:11px;line-height:1.6"><span>Fecha entrega</span><span style="font-weight:900">' + fmt(rep.fechaEntrega || new Date().toISOString().slice(0, 10)) + '</span></div>'
    + pdfTSection('Cliente', '<div style="font-weight:900">' + rep.clienteNombre + '</div><div style="font-size:11px">Tel: ' + (rep.clienteTel || '—') + '</div>')
    + pdfTSection('Equipo', '<div style="font-weight:900">' + (rep.tipoEquipo ? rep.tipoEquipo + ' - ' : '') + rep.equipo + '</div>' + (rep.sn ? '<div style="font-size:11px">S/N: ' + rep.sn + '</div>' : ''))
    + (rep.trabajos ? pdfTSection('Trabajos realizados', '<div style="font-size:11.5px;line-height:1.6;white-space:pre-line">' + rep.trabajos + '</div>') : '')
    + '<div style="border:none;border-top:2px solid #000;margin:6px 0"></div>'
    + '<table style="table-layout:fixed;width:100%;border-collapse:collapse"><thead><tr>'
    + '<th style="width:44%;border-bottom:2px solid #000;border-top:1px solid #000;padding:4px 3px;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.5px">Concepto</th>'
    + '<th style="width:9%;text-align:center;border-bottom:2px solid #000;border-top:1px solid #000;padding:4px 3px;font-size:10px;font-weight:900;text-transform:uppercase">Ud</th>'
    + '<th style="width:23%;text-align:right;border-bottom:2px solid #000;border-top:1px solid #000;padding:4px 3px;font-size:10px;font-weight:900;text-transform:uppercase">P.u.</th>'
    + '<th style="width:24%;text-align:right;border-bottom:2px solid #000;border-top:1px solid #000;padding:4px 3px;font-size:10px;font-weight:900;text-transform:uppercase">Total</th>'
    + '</tr></thead><tbody>' + filasLineas + '</tbody></table>'
    + '<div style="border:none;border-top:2px solid #000;margin:6px 0"></div>'
    + '<div style="font-size:11px;line-height:1.5">' + pdfTRow('Base imponible', formatEur(base), true) + ivaRows + '</div>'
    + '<div style="border:2.5px solid #000;padding:6px 10px;margin:5px 0;background:#f5f5f5"><div style="display:flex;justify-content:space-between;font-size:18px;font-weight:900"><span>TOTAL</span><span>' + formatEur(total) + '</span></div></div>'
    + (rep.pago ? pdfTRow('<span style="font-size:11px;margin-top:4px">Forma de pago</span>', '<span style="font-weight:900">' + rep.pago + '</span>', true) : '')
    + '<div style="margin-top:6px;padding-top:5px;border-top:1px dashed #555;text-align:center">' + pie + '</div>';
}

export async function pdfReparacion(rep, config) {
  const div = mountTicketContainer(buildResguardoHtml(rep, config));
  await renderToJpg(div, rep.num + '-resguardo.png');
}

export async function pdfEntregaReparacion(rep, config) {
  const div = mountTicketContainer(buildEntregaHtml(rep, config));
  await renderToJpg(div, rep.num + '-entrega.png');
}
